export const version = "wallet/5.0.10";
//# sourceMappingURL=_version.js.map